export default "__VITE_ASSET__646d925c__"